import React, { useEffect, useState } from "react";
import {
    createCategory,
    updateCategory,
    getCategory,
    destroyCategory,
} from "../../../../_api/Category";
import { useNavigate, useParams } from "react-router-dom";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { Button } from "../../../../_helpers/components/Button";
import toast from "react-hot-toast";
import { BackButton } from "../../../../_helpers/components/BackButton";

const AddSocioPro = () => {
    const navigate = useNavigate();
    const { category_id } = useParams();
    const [name, setName] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const loadSocioPro = async () => {
        setIsLoading(true);
        if (category_id) {
            await getCategory(category_id)
                .then((resp) => {
                    setName(resp.data.name);
                })
                .catch((resp) => {
                    toast("Accès refusé.");
                    navigate("/company/socio-professional");
                });
        }
        setIsLoading(false);
    };

    useEffect(() => {
        loadSocioPro();
    }, [category_id]);

    const addCategory = () => {
        const payload = {
            name,
        };
        setIsSaving(true);
        const request = category_id
            ? updateCategory(category_id, payload)
            : createCategory(payload);
        request
            .then(() => {
                toast(category_id ? "Modification enregistrée." : `La catégorie "${payload.name}" a été créée.`);
                navigate("/company/socio-professional");
            })
            .catch(() => {
                toast("Une erreur est survenue lors de l'enregistrement de la catégorie.");
            })
            .finally(() => setIsSaving(false));
    };

    const deleteCategory = () => {
        if (!category_id) return;
        setIsDeleting(true);
        destroyCategory(category_id)
            .then(() => {
                toast(`La catégorie "${name}" a été supprimée.`);
                navigate("/company/socio-professional");
            })
            .catch(() => {
                toast("Erreur lors de la suppression.");
            })
            .finally(() => setIsDeleting(false));
    };

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                onClick={() => navigate("/company/socio-professional")}
                                title="Retour"
                            />
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {category_id ? "Modifier" : "Ajouter"} une catégorie
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    {category_id ? "Modifiez" : "Créez"} une catégorie socio-professionnelle
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {category_id && (
                                <Button
                                    action={() => deleteCategory()}
                                    type={"red"}
                                    name={"Supprimer"}
                                    loading={isDeleting}
                                />
                            )}
                            <Button
                                action={() => addCategory()}
                                name={category_id ? "Modifier" : "Ajouter"}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {isLoading ? (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="flex items-center justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary"></div>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <InputForm
                            name="Nom"
                            value={name}
                            placeholder="Nom"
                            type="text"
                            set={setName}
                            required={true}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddSocioPro;
